import React from 'react';
import { localsMessages } from '../utility/getTemplateData';
import { Row, Col } from '@paypalcorp/pp-react';
import ConfirmationBody from './ConfirmationBody';
import ConfirmationTitle from './ConfirmationTitle';
import ConfirmationView from './ConfirmationView';
import PendingWarning from '../components/PendingWarning';
import PropTypes from 'prop-types';
import withConfirmationData from './withConfirmationData';
import withConfirmationMessages from './withConfirmationMessages';

const messages = localsMessages('confirmation/pending');

function PendingView(props) {
  const { label } = messages;
  const { pending, pending2 } = label;

  const PendingMessage = () => (
    <>
      <Row>
        <Col xs={12} className="text-center">
          <ConfirmationTitle message={pending} />
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="text-center">
          <ConfirmationBody message={pending2} />
        </Col>
      </Row>
    </>
  );

  return (
    <ConfirmationView
      {...props}
      accountMessage={messages.label.accountMessage}
      accountLink={messages.label.accountLink}
      engamentText={messages.label.engamentText}
      illustration={<PendingWarning />}
      message={<PendingMessage />}
    />
  );
}

PendingView.propTypes = {
  handleRedirect: PropTypes.func,
  orgName: PropTypes.string,
  returnTo: PropTypes.string,
  returnTextMember: PropTypes.string,
};

export default withConfirmationData(
  withConfirmationMessages(PendingView, messages)
);
